// @flow
export { default } from './CheckoutFailTemplate';



// WEBPACK FOOTER //
// ./src/components/checkout/CheckoutFailTemplate/index.js